"use client";

import dynamic from "next/dynamic";
import type { ComponentType } from "react";

function Loading(): null {
  return null;
}

const TOOL_COMPONENTS: ReadonlyMap<string, ComponentType> = new Map([
  [
    "ascii-logo-generator",
    dynamic(() => import("@/content/tools/ascii-logo-generator/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "favicon-generator",
    dynamic(() => import("@/content/tools/favicon-generator/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "heading-structure-analyzer",
    dynamic(() => import("@/content/tools/heading-structure-analyzer/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "image-to-ascii",
    dynamic(() => import("@/content/tools/image-to-ascii/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "investment-calculator",
    dynamic(() => import("@/content/tools/investment-calculator/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "ip-info",
    dynamic(() => import("@/content/tools/ip-info/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "keyboard-speed-trainer",
    dynamic(() => import("@/content/tools/keyboard-speed-trainer/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "meta-tags-analyzer",
    dynamic(() => import("@/content/tools/meta-tags-analyzer/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "og-image-preview",
    dynamic(() => import("@/content/tools/og-image-preview/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "password-generator",
    dynamic(() => import("@/content/tools/password-generator/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "robots-txt-generator",
    dynamic(() => import("@/content/tools/robots-txt-generator/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "robots-txt-validator",
    dynamic(() => import("@/content/tools/robots-txt-validator/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "sitemap-validator",
    dynamic(() => import("@/content/tools/sitemap-validator/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
  [
    "word-character-counter",
    dynamic(() => import("@/content/tools/word-character-counter/tool"), {
      loading: Loading,
      ssr: false,
    }),
  ],
]);

export function getToolComponent(toolId: string): ComponentType | undefined {
  return TOOL_COMPONENTS.get(toolId);
}
